import { render } from "./MorphToField.vue?vue&type=template&id=346d0b4b"
import script from "./MorphToField.vue?vue&type=script&lang=js"
export * from "./MorphToField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/danielarabia/code/rea-nova/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"MorphToField.vue"]])

export default __exports__